import { AsyncPipe, DecimalPipe, KeyValuePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, QueryList, ViewChildren, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { NgbdSortableHeader, SortEvent } from './../../../core/directives/sortable.directive';
import { FormsModule } from '@angular/forms';
import { NgbPaginationModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { ITableColumn } from '@core/interfaces/itable-column';
import { IAction } from '@core/interfaces/i-action';
import { TableSubscriber } from '@core/services/tableSubscriber.service';
import { faEdit } from '@fortawesome/free-regular-svg-icons';
import { faUserTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@Component({
    selector: 'app-subscriber-table',
    templateUrl: './subscriber-table.component.html',
    styleUrls: ['./subscriber-table.component.scss'],
    imports: [
    DecimalPipe,
    FormsModule,
    AsyncPipe,
    NgbTypeaheadModule,
    NgbdSortableHeader,
    NgbPaginationModule,
    KeyValuePipe,
    CommonModule,
    FontAwesomeModule
],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [TableSubscriber, DecimalPipe]
})

export class SubscriberTableComponent {
  @Input() data: any = [];
  @Output() iconClick: EventEmitter<IAction> = new EventEmitter<IAction>();

  faEdit = faEdit;
  faUserTimes = faUserTimes;

  columns: ITableColumn[] = [
    {
      scope: 'col',
      sortableName: 'email',
      label: 'Email',
    },
    {
      scope: 'col',
      label: 'Edit',
      icon: faEdit,
    },
    {
      scope: 'col',
      label: 'Delete',
      icon: faUserTimes,
    },
  ];

  records$: Observable<any[]>;
  total$: Observable<number>;

  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;

  constructor(public service: TableSubscriber) {
    this.records$ = service.records$;
    this.total$ = service.total$;
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.service.sortColumn = column;
    this.service.sortDirection = direction;
  }

  handleAction(record: any, col: any): void {
    this.iconClick.emit({ record, col });
  }
}
